import {
  EDIT_USUARIO,
  FETCH_USUARIO,
  FETCH_USUARIOS,
  SET_FILTRO_USUARIOS,
  FETCH_TOKEN_RESET_PASSWORD,
  LOADING_USUARIOS
} from './types';
import {
  postSearchUsuario,
  obtenerUsuariosDeSeller,
  requestTokenResetPassword
} from '../api/axios';

export const userTypeIds = {
  isCategory: 1,
  isAdminMod: 2,
  isSellerAdmin: 3,
  isSeller: 4,
  isResetPassword: 5,
  isSoloLectura: 6,
  isProveedor: 7,
}

export const getUserTypes = (tipoUsuario) => {
  return Object.keys(userTypeIds).reduce((previous, userType) => ({
    ...previous,
    [userType]: userTypeIds[userType] === tipoUsuario,
  }), {})
};

export const editUsuario = (usuario) => dispatch => {
  dispatch({
    type: EDIT_USUARIO,
    payload: usuario
  });
};

export const setFiltroUsuarios = (params) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: SET_FILTRO_USUARIOS,
      payload: params
    });
    resolve();
  });
};

export const fetchTokenResetPassword = (params) => async dispatch => {
  let payload = requestTokenResetPassword(params)
  dispatch({
    type: FETCH_TOKEN_RESET_PASSWORD,
    token: payload
  });
};

export const fetchUsuarios = (params) => async dispatch => {
  dispatch({
    type: LOADING_USUARIOS,
    payload: true
  });

  let response = obtenerUsuariosDeSeller(params);
  let usuarios;

  response.then(function (value) {
    const { elementos, cantidadTotal, cantidadPagina } = value.data;

    usuarios = elementos;
    usuarios["cantidadTotal"] = cantidadTotal;
    usuarios["cantidadPagina"] = cantidadPagina;

    dispatch({
      type: FETCH_USUARIOS,
      payload: usuarios
    });

    dispatch({
      type: LOADING_USUARIOS,
      payload: false
    });
  });
};

export const fetchUsuario = (data) => async dispatch => {
  let usuario = postSearchUsuario(data);

  usuario.then(function (value) {
    let user = value.data;
    dispatch({
      type: FETCH_USUARIO,
      payload: user
    });
  });
};